import { useDispatch, useSelector } from 'react-redux';
import { useEffect, lazy, Suspense } from 'react';
import FJAction from './action/FJAction';
import FJUtil from './util/FJUtil';
import Styles from './App.module.less';

const SinglePage = lazy(() => import('./components/SinglePage/SinglePage'));
const PopupPage = lazy(() => import('./components/PopupPage/PopupPage'));

const AppContent = () => {
    const dispatch = useDispatch();
    const state = useSelector(state => {
        return {
            show: state.mainStore.show,
            method: state.mainStore.method,
            page: state.mainStore.page,
        };
    });

    useEffect(() => {
        const email = FJUtil.getQueryString('email');
        if (email) {
            dispatch(FJAction.changeEmail(email));
        }
    }, []);

    return state.show ? (
        <div className={Styles.content}>
            <Suspense fallback={null}>
                {state.method === 'single' && <SinglePage page={state.page} />}
                {state.method !== 'single' && <PopupPage page={state.page} />}
            </Suspense>
        </div>
    ) : null;
};
export default AppContent;
